module.exports = __webpack_public_path__ + "static/media/landing-3.ae42bffe.png";